import React from 'react';
import Pages from './Pages.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';

const ParadigmsImages = [
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/paradigms/3551665488994-pic-hd.jpg',
    },

    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/paradigms/3561665488998-pic-hd.jpg',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/paradigms/3571665489001-pic-hd.jpg',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/paradigms/3581665489003-pic-hd.jpg',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/paradigms/3591665489007-pic-hd.jpg',
    },
]


class Inclusivity extends Pages {
    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }

    leftmenu = () => {
        return (
            <div className='leftmenu'>
                <div>Inclusivity</div>
                <br />
                <button onClick={() => this.scroll(this.firstRef)} className={'section'}> Cultural Inclusivity </button>
                <button onClick={() => this.scroll(this.firstRef)} className={'subsection'}> Tec Chihuahua x HKU Audiobook </button>
                <button onClick={() => this.scroll(this.secondRef)} className={'subsection'}> AMPed the podcast</button>

                <button onClick={() => this.scroll(this.thirdRef)} className={'section'}> Female Empowerment </button>
                <button onClick={() => this.scroll(this.thirdRef)} className={'subsection'}> Instagram Posts</button>

                <button onClick={() => this.scroll(this.fourthRef)} className={'section'}>  LGBTQ+ Inclusivity </button>
                <button onClick={() => this.scroll(this.fourthRef)} className={'subsection'}> Paradigms</button>


                <button onClick={() => this.scroll(this.fifthRef)} className={'section'}> Disability </button>
                <button onClick={() => this.scroll(this.fifthRef)} className={'subsection'}> Instagram Posts</button>

            </div>
        )
    }
    righttext = () => {
        return (
            <div className='righttext'>
                <h1 ref={this.firstRef}>Cultural Inclusivity </h1>
                {/* <br /> */}
                <h2 > Tec Chihuahua x HKU Audiobook</h2>
                <p>
                    <br />
                    <i>“Ideas are only as powerful as one can understand it”</i>
                    <br /><br />
                    To many, science may be seen as being rather complicated and tedious, and some may even perceive the ability to understand science as being exclusive to persons with certain literacy backgrounds.
                    <br /><br />
                    This year, we set our eyes on making synthetic biology accessible to everyone - specifically targeting persons of less scientific and literate backgrounds. We saw an opportunity to use our multilingualism within and around iGEM teams to create a synthetic biology audiobook.
                    <br /><br />
                    Together with iGEM Tec Chihuahua, we co-created and co-produced an audiotaped storybook. Through story-telling, we hope to engage inexperienced learners regardless of their familiarity with science and biology. Deliberately incorporating day-to-day vocabularies and analogies, we aimed to tailor our audiobook to be accessible to a diverse audience regardless of their proficiency in science, literacy and linguistic abilities.
                    <br /><br />
                    Our final audiobook has 5 short stories and a 3-chapter sequel about synthetic biology applications around us and the projects developed by the authoring teams.
                    To broaden our reach, we launched the audiobook online and translated it into at least 4 languages (English, Cantonese, Mandarin and Español). Unlike a traditional paperback storybook, by keeping our audiobook accessible over the internet for free helps cross over socio-economic and geographical boundaries. We hope that our audiobook helps inspire our audiences and propagate science as being accessible and inclusive to all. Our team also reached out to local charities such as BGCA, kidz4kidz in Hong Kong for the distribution of the audiobook.
                    <br /><br />
                    The audiobook is published via different mediums such as Spotify and Youtube.
                    <br />
                    <a href={'https://open.spotify.com/show/2MXxAdtckNBKcFQTR9O3Wo '} target="_blank" rel="noreferrer" > Listen on Spotify</a>
                    <br />
                    <a href={'https://youtu.be/yEqRbgNZQFk '} target="_blank" rel="noreferrer"  > Listen on Youtube</a>
                </p>
                <br />
                <h2 ref={this.secondRef}> AMPed the podcast</h2>
                <p>
                    <br />
                    This year, we created AMPed, a podcast where our teammates and other invited guests talk about topics in science, inclusivity, and diversity. In our first episode, our teammates,  Rita and Christian, discuss their experiences as Third Culture Kids – individuals who spent a significant part of their developmental years in one or more countries outside their parents’ culture. During the podcast, Rita and Christian share their experiences and the struggles they faced in science education as TCKs. In our second episode, we invited Kiran, an ethnic minority student studying nutrition science at HKU. Kiran was born and raised in Hong Kong and knew how to speak both Cantonese and English fluently. During this episode, Kiran talks about her struggles with identification, racism, and trying to fit into Hong Kong’s community as an ethnic minority. In our third episode, our fellow igemer, Rita, was interviewed. During this episode, Rita chats about why she pursued biotechnology, her struggles, and some of her role models in science.
                    <br /><br />
                    The podcast is available on various online platforms such as Spotify.
                    <br />
                    <a href='https://open.spotify.com/show/0Gk3xj1RNxCaVn5YFTNjNw ' target="_blank" rel="noreferrer" > Click to listen</a>
                </p>
                <br />
                <h1 ref={this.thirdRef}>Female Empowerment  </h1>
                <h2 > Instagram Posts</h2>
                <p>
                    <br />
                    We also created a series of instagram posts to promote diversity in science. For example, as October is the Nobel Prize season, we created a post to celebrate the achievements of female nobel laureates hoping to raise awareness and empower fellow women in Science.
                    <br /><br />
                    <img src='https://static.igem.wiki/teams/4241/wiki/ihp/ins-post/screenshot-2022-10-11-at-6-44-11-pm.png' alt='' style={{ width: '70%' }} />
                </p>
                <br />
                <h1 ref={this.fourthRef}>LGBTQ+ Inclusivity  </h1>
                <h2 > Paradigms</h2>
                <p>
                    <br />
                    Our members were invited by Astreas, a student-led expressive arts organization at HKU to present a photography exhibit at their exhibition showcase, Paradigms. The goal of this queer exhibition showcase is to give Hong Kong-based artists a venue to display works that represent LGBTQ+ viewpoints. The project includes a demonstration of several artistic mediums, such as poetry, photography, and various painting types, as well as a dance performance that portrays queer lives using dance genres including jazz, modern contemporary, and ballet. For this exhibition, members of our iGEM team who identify as queer, LGBTQ+, or allies created a collection of portrait photographs that celebrates our identities. The show was set on Sunday, 9th of October, 2022.
                    <br /><br />
                    <i>Photos of our exhibit at Paradigms:</i>
                </p>
                {this.sildeshowRender(ParadigmsImages)}
                <br />
                <h1 ref={this.fifthRef}>Disability  </h1>
                <h2 > Instagram Posts</h2>
                <p>
                    <br />
                    To celebrate Hong Kong Sign Language Day, which was held on September 18th, our science and communication team created a series of posts to promote HKSL which is Hong Kong’s official sign language. We try to educate the public on the significance of HKSL as well as common science terminologies in the language. Through researching and creating the post, we realized how scientific terminologies in HKSL are extremely limiting, hindering science education for the deaf. Thus in the future, our team wishes to reach out to organizations such as The Hong Kong Society for the Deaf to learn more about enhancing science education for the deaf community in Hong Kong.
                    <br /><br />
                    <img src='https://static.igem.wiki/teams/4241/wiki/ihp/ins-post/screenshot-2022-10-12-at-7-12-36-pm.png' alt='' style={{ width: '70%' }} />
                </p>



            </div>
        )
    }

    render() {
        return (
            <>
                {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
                <h1 className='des'>Inclusivity</h1>
                <div className='pageholder'>

                    {this.leftmenu()}
                    {this.righttext()}
                </div>
            </>
        )
    }
}


export default Inclusivity;
